/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UiTemplate {
  Open = 'Open',
  OpensToday = 'OpensToday',
  OpensTomorrow = 'OpensTomorrow',
  OpensWeekday = 'OpensWeekday',
  Closed = 'Closed',
  ClosesToday = 'ClosesToday'
}
